import React from "react";
import Navbar from "../headers_footer/navbar";
import Flexproducts from "./flexproducts";
import Header from "../headers_footer/header";

const Makeup = () => {

return (

<div>

<Navbar />
<Flexproducts type="makeup" />
<Header></Header>

</div>

);
};

export default Makeup;